import './PageTitle.css';



const PageTitle = ({ title }) => {
  return (
    <div className="pagetitlebox">
      <p className='pagetitle'>{title}</p>
    </div>
  );
}
export default PageTitle;


